import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import ComplianceContent from '../components/Compliance/ComplianceContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from './../redux/language/selector';

const Compliance = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('compliance-page.compliance-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
      <NavbarTop />
      <ComplianceContent />
      
    </>
  )
}

export default Compliance